import { useEffect, useState } from 'react';
import Modal from '../Modal';
import { repositorioFazenda } from '../../sync/repositories/fazendas';
import { repositorioPasto } from '../../sync/repositories/pecuaria';
import { extrairMensagensErro } from '../../utils/errorUtils';

const ESTADO_INICIAL = {
  fazenda: '', nome: '', area_hectares: '', tipo_forragem: '', produtividade_kg_ha: '',
};

/** Modal de cadastro rápido de Pasto. Busca a lista de fazendas sozinho ao abrir. */
export default function ModalCadastroPasto({ isOpen, onClose, onSuccess, fazendaSelecionadaId = null }) {
  const [dados, setDados] = useState(ESTADO_INICIAL);
  const [fazendas, setFazendas] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [erros, setErros] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setDados(ESTADO_INICIAL);
      setErros([]);
      setSalvando(false);
      return;
    }
    repositorioFazenda.listar()
      .then((resp) => setFazendas(Array.isArray(resp.data) ? resp.data : (resp.data.results || [])))
      .catch(() => setFazendas([]));
    setDados((prev) => ({ ...prev, fazenda: fazendaSelecionadaId || '' }));
  }, [isOpen, fazendaSelecionadaId]);

  const handleChange = (campo) => (e) => setDados((prev) => ({ ...prev, [campo]: e.target.value }));

  const handleSalvar = async (e) => {
    e?.preventDefault?.();
    if (!dados.fazenda) { setErros(['Selecione a fazenda.']); return; }
    if (!dados.nome.trim()) { setErros(['O nome é obrigatório.']); return; }
    if (!dados.area_hectares) { setErros(['Informe a área em hectares.']); return; }
    if (!dados.tipo_forragem.trim()) { setErros(['Informe o tipo de forragem.']); return; }
    if (!dados.produtividade_kg_ha) { setErros(['Informe a produtividade.']); return; }
    setSalvando(true);
    setErros([]);
    try {
      const resp = await repositorioPasto.criar({
        fazenda: dados.fazenda,
        nome: dados.nome.trim(),
        area_hectares: Number(dados.area_hectares),
        tipo_forragem: dados.tipo_forragem.trim(),
        produtividade_kg_ha: Number(dados.produtividade_kg_ha),
      });
      onSuccess?.(resp.data);
      onClose?.();
    } catch (error) {
      setErros(extrairMensagensErro(error));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={salvando ? () => {} : onClose} title="Cadastrar Pasto">
      <form onSubmit={handleSalvar} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Fazenda *</label>
          <select
            value={dados.fazenda}
            onChange={handleChange('fazenda')}
            disabled={salvando}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300 bg-white"
          >
            <option value="">Selecione...</option>
            {fazendas.map((f) => <option key={f.id} value={f.id}>{f.nome}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nome *</label>
          <input
            type="text"
            value={dados.nome}
            onChange={handleChange('nome')}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            autoFocus
            disabled={salvando}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Área (ha) *</label>
            <input
              type="number" step="0.01" min="0"
              value={dados.area_hectares}
              onChange={handleChange('area_hectares')}
              className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
              disabled={salvando}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Produtividade (kg/ha) *</label>
            <input
              type="number" step="0.01" min="0"
              value={dados.produtividade_kg_ha}
              onChange={handleChange('produtividade_kg_ha')}
              className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
              disabled={salvando}
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Forragem *</label>
          <input
            type="text"
            value={dados.tipo_forragem}
            onChange={handleChange('tipo_forragem')}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            disabled={salvando}
          />
        </div>
        {erros.length > 0 && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 space-y-1">
            {erros.map((m, i) => <div key={i}>{m}</div>)}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} disabled={salvando}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50">
            Cancelar
          </button>
          <button type="submit" disabled={salvando}
            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white disabled:bg-blue-300">
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
